import React from 'react';
import { Cta, CtaBanner, IBanner, ICloud } from '../../types/content';
import './Banners.scss';
import ScrollAnimation from '../ScrollAnimation/ScrollAnimation';
import CONFIG from '../../config';
import { getImage, adobeTrack, getNavigationPageLink, gamingListWithAccess } from '../../utils';
import LearnMoreButton from '../UI/Buttons/LearnMoreButton';
import PictureImage from '../UI/Image/Picture';
import { useSelector } from 'react-redux';
import { IContent } from '../../types';
import { withContent } from '../../hoc/withContext';
import DiscoverButton from '../UI/Buttons/DiscoverButton';
import { GreyButton } from '../UI/Buttons/GreyButton/GreyButton';
import { IAppState, IState } from '../../types/store/reducer';
import { ReactComponent as CaretComponent } from '../../assets/caretSvg.svg';

interface IBannerProps {
  bannerItem: IBanner;
  ctas: Cta;
  cloudBanner: boolean;
  context?: IContent;
  appState? :IAppState;
}

//Gets needed cloud platforms for display
const getCloudItems = (cloudItems: ICloud[],appState : IAppState) => {
  return cloudItems.filter((cloudItem : ICloud) => appState[cloudItem.availabilityKey]).map((platform: ICloud, index: number) => {
    return (
      <div
        className={`cloud-platform-item ${
          index !== 0 ? 'cloud-platform-margin' : ''
        }`}
        key={platform.image.alt}
      >
        <PictureImage
          images={[{
            imageName: platform.image.link,
            minWidth: 0
          }]}
          extension="png"
          altText={platform.image.alt}
          key={'cloud-item-' + index}
          className={[
            `${
              cloudItems.length > 1 ? 'dual-cloud-item-margin' : ''
            } cloud-platform-image  lazyload`
          ]}
        />
      </div>
    );
  });
};

//Banner structure
const BannerRender =({ bannerItem, ctas, cloudBanner, context, appState }: IBannerProps) =>  {
  return (
    <section
      className={
        'banner_container ubisoft-plus_container ' +
        (bannerItem.image_direction === 'left' ? 'image_left' : 'image_right')
      }
    >
      <h2
        className="banner_title_mobile"
        dangerouslySetInnerHTML={{ __html: bannerItem.title }}
      />

      <div className={'banner_image'}>
        <ScrollAnimation
          animateIn="scaleUp"
          animatePreScroll={false}
          className="image-wrapper"
        >
          <PictureImage
            images={getImage(bannerItem.image.link)}
            extension="png"
            altText={bannerItem.image.alt}
          />
        </ScrollAnimation>
      </div>
      <div
        className={`banner_text_container`}
      >
        <div className="banner_text">
          {/*Setup Title*/}
          <h2
            className={`banner_title_PC bolden-text`}
            dangerouslySetInnerHTML={{ __html: bannerItem.title }}
          />
          {/*Setup description*/}
          <p
            className="banner_description"
            dangerouslySetInnerHTML={{ __html: bannerItem.description }}
          />
          {/*Setup cloud section*/}
          <div className="cloud_platforms_container">
            {(bannerItem.cloud !== undefined && appState.windowVariablesInitialised) &&
            getCloudItems(bannerItem.cloud,appState)}
          </div>
          {/*Setup buttons*/}
          {bannerItem.cta !== undefined && (
            <div
              className={`banner_buttons ubisoft-plus_cta_wrapper`}
            >
              {bannerItem.cta.map((cta: CtaBanner, index: number) => {
                if (cta.type === 'learn_more_cloud') {
                  return (
                    <div
                      key={'banner-button-' + index}
                      className={'cloud-learn-more-button'}
                    >
                      <GreyButton
                        content={context.cta.learn_more}
                        redirect={getNavigationPageLink('cloud')}
                      />
                    </div>
                  );
                } else if (cta.type === 'learn_more' && !CONFIG.isUPC) {
                  return (
                    <LearnMoreButton
                      key={'banner-button-' + index}
                      content={ctas[cta.type]}
                      redirect={cta.redirection}
                      handleClick={() =>
                        adobeTrack(
                          'clickevent',
                          context.tracking.download_ubisoft_connect
                        )
                      }
                    />
                  );
                } else if (cta.type === 'discover') {
                  return (
                    <DiscoverButton
                      key={'banner-button-' + index}
                      content={ctas[cta.type]}
                      cloudBanner={cloudBanner}
                      handleClick={() =>
                        adobeTrack(
                          'clickevent',
                          context.tracking.download_ubisoft_connect
                        )
                      }
                    />
                  );
                } else if(cta.type === 'view_cloud_games'){
                  return  <div className={'view-cloud-games-container'}>
                    <a className={'bolden-text'} href={gamingListWithAccess(appState.stadiaAvailable,appState.lunaAvailable)}>{ctas[cta.type]}</a>
                    <CaretComponent/>
                  </div>
                }
              })}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

//Banner display logic
const Banner = ({ bannerItem, ctas, cloudBanner, context }: IBannerProps) => {
  const appState = useSelector((state : IState) => state.app);
  //If banner item is setup for loc, only display it if either luna or stadia is available for the country
  if (bannerItem.cloud !== undefined){
    if ((appState.windowVariablesInitialised) && (appState.lunaAvailable || appState.stadiaAvailable)){
          return <BannerRender bannerItem={bannerItem} ctas={ctas} cloudBanner={cloudBanner} context={context} appState={appState}/>
    }else {
      return  <></>
    }
  }else {
    return <BannerRender bannerItem={bannerItem} ctas={ctas} cloudBanner={cloudBanner} context={context}
                         appState={appState} />
  }

};

export default withContent(Banner);
